import { sendPkByEmailApi, storePKApi } from '../utils/axios/axiosInstance';
import { axios_post, basic_get, post, put } from '../utils/axios/https';
import { getPkBackupApiKey } from './pkBackupApiKey';

export const services = {
    updateUser: (body) => put(`api/usuarioos/me/`, body, {}),
    updateAuditor: (body) => put(`api/usuarioauditor/me/`, body, {}),
    updateDrugstoreUser: (body) => put(`api/usuariodrogueria/me/`, body, {}),
    updateOS: (os_id, body) => put(`api/os/${os_id}/`, body, {}),
    updateAuditPublicKey: (id, body) => put(`api/auditoria/grupoauditor/${id}/`, body, {}),
    updateDrugstorePublicKey: (id, body) => put(`api/drogueria/${id}/`, body, {}),
    changePassword: (body) => post('auth/users/set_password/', body),
    savePKToCloud: async (body) => {
        if (!storePKApi)
            throw new Error('El backup de clave privada está deshabilitado en este entorno.');
        const apiKey = await getPkBackupApiKey();
        return axios_post(storePKApi, body, { 'x-api-key': apiKey });
    },
    sendPrivateKeyByEmail: async (email) => {
        if (!sendPkByEmailApi)
            throw new Error('El envío de clave privada está deshabilitado en este entorno.');
        const apiKey = await getPkBackupApiKey();
        return basic_get(sendPkByEmailApi + email, { 'x-api-key': apiKey });
    },
};
